module.exports = __webpack_public_path__ + "img/startConfigurationSolitair.d5aba38.png";